const func = {
	getImageSizes: (image, imageSizes) => {
		if (!image) return [];
		let options = [];
		const sizes = image.media_details.sizes;

		for (const key in sizes) {
			const imageSize = imageSizes.find(s => s.slug === key);
			if (imageSize) {
				options.push({ label: imageSize.name, value: sizes[key].source_url });
			}
		}
		return options;
	}
}
export default func;